<div class="d-flex main_div" align-items-center routerLink="/merchant/home">
    <div class="white-box" *ngIf="branchObj?.logo">
        <img [src]="branchObj?.logo" width="100%">
    </div>
    <h4>{{branchObj?.name}}</h4>
</div>